import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { AbsoluteExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/AbsoluteExpression";

export class AbsoluteExpressionEditor extends ExpressionRuleEditor<AbsoluteExpression> {
    render() {
        return (
            <ExpressionPiece>
                absolute
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
